import { useOrganisation } from "Hooks/Endpoints";
import React, { Fragment, useEffect, useState } from "react";
import { Button, Message } from "semantic-ui-react";

const OrganisationDeleteForm = () => {
  const { organisation, remove } = useOrganisation();
  const [canDelete, setCanDelete] = useState<boolean>(false);

  useEffect(() => {
    setCanDelete(organisation.customers.length === 0);
  }, [organisation]);

  if (!organisation) return <Fragment />;

  return (
    <div>
      <Message warning>
        To remove an organisation you must remove all accounts first.
      </Message>
      <Button
        color='red'
        disabled={!canDelete}
        onClick={() => remove(organisation.id)}
      >
        Delete Organisation
      </Button>
    </div>
  );
};

export default OrganisationDeleteForm;
